import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SessionItems } from 'app/enums/constants.enum';
import { Alert, AlertFilter, AlertList, AlertsPaged } from 'app/models/alerts/alert-list.model';
import { Item } from 'app/models/item.inferface';
import { AlertService } from 'app/services/alert.service';
import { DataSourceService } from 'app/services/data-source.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { AlertDetailComponent } from '../alert-detail/alert-detail.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-associate-alert',
  templateUrl: './associate-alert.component.html',
  styleUrls: ['./associate-alert.component.scss']
})
export class AssociateAlertSharedComponent implements OnInit {

  textFiltersMaxLength = 250;
  searchForm: UntypedFormGroup;
  statusData: Item[];
  sourcesData: Item[];
  resolutionsData: Item[];
  criticalitiesData: Item[];
  dataSource: MatTableDataSource<AlertList> = new MatTableDataSource([]);
  loadingDataSource = false;

  idSelected: number = null;
  @Output()
  idSelectedEmitter: EventEmitter<number> = new EventEmitter();

  columns = [
    'ALERTCODE',
    'ALERTENTITY',
    'INTERNALID',
    'SOURCEID',
    'DESCRIPTION',
    'Source.Description',
    'CREATEDDATE',
    'Criticality.Description',
    'DUEDATE',
    'Status.Description',
    'MODIFIEDDATE',
    'Resolution.Description',
  ];
  displayedColumns = [
    ...this.columns,
    'ACTIONS'
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private dataSourceService: DataSourceService,
    // public dialogRef: MatDialogRef<AssociateAlertSharedComponent>,
    public dialog: MatDialog,
  ) { 
    this.dataSourceService.getAlertStatus().subscribe(
      res => {
        this.statusData = res;
      },
      err => console.log(err)
    );

    this.dataSourceService.getAlertSources().subscribe(
      res => this.sourcesData = res,
      err => console.log(err)
    );

    this.dataSourceService.getAlertResolutions().subscribe(
      res => this.resolutionsData = res,
      err => console.log(err)
    );

    this.dataSourceService.getCriticality().subscribe(
      res => this.criticalitiesData = res,
      err => console.log(err)
    );
  }

  ngOnInit(): void {
    const filterForm = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.alertlist_fitlerForm));
    
    this.searchForm = this.formBuilder.group({
      number: [null],
      status: [filterForm?.status || null],
      alertCode: [filterForm?.alertCode || null],
      description: [filterForm?.description || null],
    });

    
    this.searchForm.get('status').setValue(3);
  }

  getPaged(){
    const filter: AlertFilter = {
      pageIndex: 0,
      pageSize: 10,
      sortExpression: "",
      sources: this.searchForm.controls.sources?.value,
      alertCode: this.searchForm.controls.alertCode?.value,
      description: this.searchForm.controls.description?.value,
      statusId: this.searchForm.controls.status?.value,
    };

    this.alertService.getPaged(filter).subscribe(
      res => this.dataSource.data = res.results,
      err => console.log(err)
    );
  }

  clearFilters(){
    this.searchForm.reset();
    this.searchForm.get('status').setValue(3);
    this.getPaged();
  }

  selectAlert(alertId){
    this.idSelected = alertId;
    this.idSelectedEmitter.emit(alertId);
  }

  viewAlertDetail(alertId){
    const dialogRef = this.dialog.open(AlertDetailComponent, {
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      data: {
        id: alertId
      },
    });
    //dialogRef.close();
    dialogRef.afterClosed().subscribe(result => console.log(result))
  }

}
